import React from 'react';
import PrintSizeType from '../types/print-size-type';
import { builderDispatch } from '../../_utils/ui';
import CartItemsChangeEvents from '../cart-items-change-events';

const PrintsSizeDeleted = (size) => {
  const { title } = size;

  return (
    <div className="alert alert-warning" role="alert">
      {title} prints have been deleted.&nbsp;
      <a href="#" onClick={handleUndelete}>
        Undo
      </a>
    </div>
  );

  function handleUndelete(e) {
    e.preventDefault();

    builderDispatch.dispatch({
      type: CartItemsChangeEvents.UNREMOVE_PRINT,
      size: size,
    });
  }
};

PrintsSizeDeleted.propTypes = {
  sizes: PrintSizeType,
};
export default PrintsSizeDeleted;
